<template>
  <div class="Login">
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-5 col-lg-4 col-center">
        <md-card class="md-accent" md-theme="login">
          <md-card-media><img src="../assets/logo2_negro.png" style="padding:32px 32px 0 32px" alt=""></md-card-media>
          <md-card-content>
            <md-field @keyup.native.enter="iniciarSesion()">
              <label>Correo electrónico</label>
              <md-input v-model="usr"></md-input>
            </md-field>
            <md-field @keyup.native.enter="iniciarSesion()" :md-toggle-password="false">
              <label>Contraseña</label>
              <md-input v-model="pass" type="password"></md-input>
            </md-field>
          </md-card-content>
          <md-card-actions>
            <md-button class="md-raised md-primary" @click.native="iniciarSesion() ">Iniciar sesión</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";

export default {
  name: "Login",
  methods: {
    iniciarSesion() {
      this.$http
        .post("sesion/iniciar", {
          a: sha1(md5(this.usr)),
          b: sha1(md5(this.pass)),
          c: 0
        })
        .then(
          response => {
            if (response.status === 200 && "token" in response.body) {
              //Creamos la sesión
              this.$session.set("token", response.body.token);
              this.$session.set("nombre", response.body.nombre);
              //Mandamos mensaje de bienvenida
              this.$parent.sb.texto = "BIENVENIDO " + response.body.nombre;
              this.$parent.sb.mostrar = true;
              this.$router.push("/");
            } else {
              this.$parent.sb.texto = response.body.error;
              this.$parent.sb.mostrar = true;
            }
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor";
            this.$parent.sb.mostrar = true;
          }
        );
    }
  },
  data() {
    return {
      usr: null,
      pass: null
    };
  }
};
</script>